<script>
    import axios from "axios";
import Layout from "../../../../layouts/main";
    import PageHeader from "@/components/page-header";
import { RG_RECIPE_PATH } from "../../../../../path";
import Swal from "sweetalert2";
import moment from "moment";
    export default {
        components : {
            Layout,
            PageHeader
        },
        data(){
            return {
                title: "Recipe Card",
                items: [
                    {
                        text: "List",
                    },
                    {
                        text: "Management",
                        active: true,
                    },
                ],
                cdn : process.env.VUE_APP_AWS_CDN,
                base_url : process.env.VUE_APP_API_BACKEND_URL,
                search : '',
                currentPage : 1,
                data : [],
                fields : ['recipe_name','batch_size','version','created_at','actions'],
                selectedRecipe : null,
                status : 'pending',
            }
        },
        watch : {
            status(){
                this.getData();
            },
            currentPage(){
                this.getData();
            }
        },
        methods : {
            async getData(){
                try {
                    let res = await axios.get(this.base_url + RG_RECIPE_PATH.LIST_RECIPE_CARD,{
                        params : {
                            search : this.search,
                            page : this.currentPage,
                            status : this.status
                        }
                    });
                    if(res.data.status){
                        this.data = res.data.data;
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            async deleteData(v){
                try {
                    let res = await axios.post(this.base_url + RG_RECIPE_PATH.DELETE_RECIPE_CARD,{
                        id : v.id
                    });
                    if(res.data.status){
                        Swal.fire("Deleted Successfully");
                        this.getData();
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            formatDate(v){
                return moment(v).format('YYYY-MM-DD h:m a');
            }     
        },
        mounted(){
            this.getData()
        }
    }
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <router-link to="/add_raw_material_to_gravy_recipe_card"><b-button variant="secondary">Add Recipe Card</b-button></router-link>
        <b-card>            
            <b-table
                  :key="data.key"
                  :items="data.data"
                  :fields="fields"
                  responsive="sm"                  
                  :current-page="currentPage"
              >
              <template v-slot:cell(recipe_name)="row">
                <a target="_blank" :href="cdn + '/' + row.item.card_url">{{ row.item.recipe.recipe_name }} <i class="fa fa-download"></i></a>
              </template>
              <template v-slot:cell(version)="row">
                {{ row.item.recipe.version }}
              </template>
              <template v-slot:cell(created_at)="row">
                {{ formatDate(row.item.created_at) }}
              </template>
              <template v-slot:cell(actions)="row">                                
                <b-button variant="danger" @click="deleteData(row.item)"><i class="fa fa-trash"></i></b-button>
              </template>
            </b-table>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination :key="data.key" v-model="currentPage" :total-rows="data.total" :per-page="data.per_page"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
        </b-card>        
    </Layout>
</template>

<style>
    
</style>